import http from '../common/http-common';
import { ActualizarContrasenaDto } from '../../Componest/Catalogos/CatSistemas/DTO/DTOActualizarContrasena';
import { ControlContrasena } from '../../Componest/Catalogos/CatSistemas/DTO/DTOControlContrasena';
import { EmpleadoMasterDto } from '../../Componest/Catalogos/CatSistemas/DTO/EmpleadoMasterDto';

class ControlContrasenasServices {

   
    GetByEmpleado(numEmpleado: string) {
        return http.get<ControlContrasena[]>(
            `/ControlContrasenas/GetByEmpleado/${numEmpleado}`
        );
    }

    GetAllByEmpleado() {
        return http.get<ControlContrasena[]>(
            `/ControlContrasenas/GetAllByEmpleado`
        );
    }

    
    ActualizarContrasena(data: ActualizarContrasenaDto) {
        return http.post(
            `/ControlContrasenas/Actualizar`,
            data
        )
    }

    // 🔹 ELIMINAR contraseña
    EliminarContrasena(numEmpleado: string, tipoContrasena: string) {
        return http.delete(
            `/ControlContrasenas/Eliminar/${numEmpleado}/${encodeURIComponent(tipoContrasena)}`
        )
    }


    GetEmpleadosMaster() {
    return http.get<EmpleadoMasterDto[]>(
        `/ControlContrasenas/EmpleadosMaster`
    );
}

}

export default new ControlContrasenasServices();
